const ID_SEPARATOR = '-';

/**
 * Преобразование содержимого атрибута name в id.
 * Используется для автоматической связки меток (label) в form-item и input.
 */
const IdAdapter = {
  fromName(name) {
    if (Array.isArray(name)) {
      return name.join(ID_SEPARATOR);
    }

    return name;
  },
}

export {IdAdapter};